// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Ji-z"};